import {ChangeDetectionStrategy, Component} from '@angular/core';


@Component({
    selector: 'app-end-of-shift-reports',
    template: '<app-reports-view category="EndOfShift"></app-reports-view>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EndOfShiftReportsComponent {

    category = 'EndOfShift';

    constructor() {
    }

}
